export default {
  allWeek: 'All week',
  allDay: 'All day',
  noDays: 'No days selected',
};
